<div class="hidewhenloading" #hidewhenloading>


    <div class="row">
        <div class="col-md-6">
            <div class="card">
                <div class="card-header text-center">
                    <h4 class="display-5">School Plan</h4>
                </div>
                <div class="card-body plantiles" *ngIf="schoolplan">
                    <!-- <div class="text-center"><b>Current Plan: </b>{{schoolplan.name}}</div>
                    <div class="text-center"><b>Expiry Date: </b>{{schoolplan.currentAccountExpiryDateString}}</div> -->
                    <div class="row">
                        <div class="col-md-4"><b>Current Plan: </b></div>
                        <div class="col-md-8">{{schoolplan.name}}</div>
                    </div>
                    <div class="row">
                        <div class="col-md-4"><b>Expiry Date:</b> </div>
                        <div class="col-md-8">{{schoolplan.currentAccountExpiryDateString}}</div>
                    </div>
                </div>
                <div class="card-footer">
                    <button type="button" class="btn w-100 planSlt"
                        routerLink="/account/schoolplan">{{schoolplan?"Change":"Select"}} Plan</button>
                </div>
            </div>
        </div>
        <!-- <div class="col-md-4">
            <div class="card">   
                <div class="card-header text-center">
                    <h4 class="display-5">V-Circle Plan</h4>                    
                </div>      
                <div class="card-body plantiles"  *ngIf="vcircleplan">
                    <div class="row"><div class="col-md-4"><b>Current Plan: </b></div><div class="col-md-8">{{vcircleplan.name}}</div></div>
                    <div class="row"><div class="col-md-4"><b>Expiry Date:</b> </div><div class="col-md-8">{{vcircleplan.currentAccountExpiryDateString}}</div></div>
                </div>
                <div class="card-body plantiles"  *ngIf="!vcircleplan">
                    <h2>No Running Subscription</h2>
                </div>
                <div class="card-footer">
                    <button type="button" class="btn w-100 planSlt" (click)="vcircleclick()">{{vcircleplan?"Change":"Select"}} Plan</button>
                </div>
            </div>
        </div>                -->
        <div class="col-md-6">
            <div class="card">
                <div class="card-header text-center">
                    <h4 class="display-5">Account Details</h4>
                </div>
                <div *ngIf="regionId === 1">
                    <div class="card-body plantiles" *ngIf="school && school.accountName">
                        <div class="row">
                            <div class="col-md-4"><b>Account Name: </b></div>
                            <div class="col-md-8">{{school.accountName}}</div>
                        </div>
                        <div class="row">
                            <div class="col-md-4"><b>Account Number:</b> </div>
                            <div class="col-md-8">{{school.accountNumber}}</div>
                        </div>
                        <div class="row">
                            <div class="col-md-4"><b>Bank: </b> </div>
                            <div class="col-md-8">{{school.bank}}</div>
                        </div>
                    </div>
                    <div class="card-body plantiles" *ngIf="!school || !school.accountName">
                        <h2>Account Details Not Set</h2>
                    </div>
                </div>
                <div *ngIf="regionId !== 1">
                    <div class="card-body plantiles" *ngIf="school && school.stripeAccountId">
                        
                        <div class="d-flex flex-column ">
                            <h4 class="text-center"><b>Stripe Account Status</b></h4>
                            <div class="row">
                                <div class="col-md-8">Can receive payments</div>
                                <div *ngIf="stripeAccountStatus?.chargesEnabled; else noCharges" class="col-md-4">
                                    <i class="fas fa-check"></i>
                                </div>
                                <ng-template #noCharges>
                                    <div class="col-md-4">
                                        <i class="fa fa-times"></i>
                                    </div>
                                </ng-template>
                            </div>
                            <div class="row">
                                <div class="col-md-8">Can receive payouts</div>
                                <div *ngIf="stripeAccountStatus?.payoutsEnabled; else noPay" class="col-md-4">
                                    <i class="fas fa-check"></i>
                                </div>
                                <ng-template #noPay>
                                    <div class="col-md-4">
                                        <i class="fa fa-times"></i>
                                    </div>
                                </ng-template>
                            </div>
                            <div class="row">
                                <div class="col-md-8">Completed onboarding </div>
                                <div *ngIf="stripeAccountStatus?.detailsSubmitted; else noDetails" class="col-md-4">
                                    <i class="fas fa-check"></i>
                                </div>
                                <ng-template #noDetails>
                                    <div class="col-md-4">
                                        <i class="fa fa-times"></i>
                                    </div>
                                </ng-template>
                            </div>
                        </div>
                    </div>
                    <div class="card-body plantiles" *ngIf="!school || !school.stripeAccountId">
                        <h2>Account Details Not Set</h2>
                    </div>
                </div>
                
                <div class="card-footer">
                    <button *ngIf="school?.stripeAccountId" (click)="gotoStripeLink()" type="button" class="btn w-100 planSlt">
                        Go to stripe dashboard
                    </button>
                    <button *ngIf="school?.stripeAccountId?.length <= 0 " type="button" class="btn w-100 planSlt" 
                        routerLink="/account/accountdetails">
                            {{school?.accountName ? "Change":"Create"}} Account Details
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>


<div class="container mt-4" *ngIf="stripeAccountStatus?.requirements?.length">

  <div class="card shadow-sm">
    <div class="card-header bg-danger text-dark">
      <h5 class="mb-0">Account Setup Required</h5>
    </div>

    <div class="card-body">
      <p class="mb-3">
        Your account is not fully set up yet. Reasons:
      </p>

      <ul class="list-group mb-3">
        <li 
          class="list-group-item d-flex justify-content-between align-items-center"
          *ngFor="let req of stripeAccountStatus?.requirements">

          <div>
            <h5><strong>Awaiting action from:</strong> </h5> <h6>{{ req.awaiting_action_from }}</h6>
          </div>
          <div>
            <h5><strong>Description:</strong></h5> <h6>{{ req.description }}</h6>
          </div>
          <span class="badge bg-danger">Required</span>
        </li>
      </ul>

      <button class="btn btn-primary w-100" (click)="gotoStripeLink()">
        Complete Setup
      </button>
    </div>
  </div>

</div>